import React, { Component } from 'react';
import Images from '../Assets/Images';
import '../../riskwell/Styles/Login.scss';
import Api from '../Services/Api'
import CircularProgress from '@material-ui/core/CircularProgress';
import { toastr } from 'react-redux-toastr'


class ForgotPassword extends Component {

  constructor (props){
    super(props)
    this.state = {
      email:"",
      pathUrl: this.props.location.state,
      enableSubmit:false
    }    
  }

  cancelForgotPassword = (event)  => {
      event.preventDefault();
      if(this.state.pathUrl){
        this.props.history.push(this.state.pathUrl);
      }else{
        this.props.history.push("/");
      }      
  }

  handleEmail = (e) => {

    if(e.target.value !=''){
      this.setState({
        email: e.target.value,
        loader:false,
        enableSubmit:true 
      })
    }else{
      this.setState({
        email: '',
        loader:false,
        enableSubmit:false 
      })
    }    
  }

  subMittingData = async(e) => {
    this.setState({
      loader:true      
    })
    e.preventDefault();
    const params = {
      tenantEmail: this.state.email,
      TenantKey: this.props.match.params.id
    }
    let result =  await Api.resetPassword(params)
    this.setState({
      loader:false
    })
    if (result.status === 200){
      toastr.success(result.message)
      this.setState({
        email:"",
        enableSubmit:false
      })
      this.props.history.push(this.state.pathUrl);
    }else {
      this.setState({
        loader:false,
        enableSubmit:false
      })
      toastr.error(result.message)
    }
  }

  render() {
    return (
      <div className="auth-wrapper">
        <div className="auth-inner">
          <div className="authCont">
            <div className="logo">
                <img src={Images.RISKWELLLOGO} alt="Logo" width="200"/>
            </div>
                <h4>Forgot Password</h4>
                <p>Don't worry. Resetting your password is easy, just tell us the email address you register.</p>
                <form className="profile-form" >
                  <div className="form-group">
                        <div className="ip-field">
                            <input value={this.state.email} type="email" autoComplete="off"  onChange={(e)=>this.handleEmail(e)} className="noMargin form-control" id="email" placeholder="Email Address"/>
                            <span style={{cursor:"text",width:"17px"}}>
                                <img src={Images.MAIL} alt="User" width="17"/>
                            </span>
                        </div>
                    </div>
                    
                    <button disabled={!this.state.enableSubmit} onClick={(e)=>this.subMittingData(e)} className="btn btn-primary btn-block btn-rounded relPosition" >Submit
                      {/* Spinner */}
                      {this.state.loader ? <span className="MatBtnSpinner">
                                    <CircularProgress style={{'color': '#FFFFFF'}} size={22}/>
                                </span> : null}
                    </button>
                    <button type="button" onClick={(e)=>{this.cancelForgotPassword(e)}} className="btn btn-primary btn-transparent">Cancel</button>
                  </form>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
